<template>
  <div class="contact_container">
    <div class="section">
      <img :src="icon">
      <span class="title">{{ name }}</span>
    </div>
    <div class="note">
      <span>{{ note }}</span>
      <span style="margin-top: 10px">{{ noteZh }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactCon',
  props: {
    icon: { type: String, default: '' },
    name: { type: String, default: '' },
    note: { type: String, default: '' },
    noteZh: { type: String, default: '' },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.contact_container {
  .section {
    display: flex;
    align-items: center;
    img {
      width: 48px;
      height: 48px;
    }
    .title {
      font-weight: bold;
      font-size: 48px;
      color: #fff;
      letter-spacing: 2;
      margin-left: 11px;
    }
  }
  .note {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    span {
      color: #fff;
      opacity: 0.6;
      font-size: 32px;
    }
  }
}
</style>
